import React, { useEffect } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';
import "../../assets/Style.css";

import founderImg from '../../assets/images/founder.png';
import cofounderImg from '../../assets/images/cofounder.png';

const TeamSection = () => {
    useEffect(() => {
        const slider = $('.team-slider');
        if (slider.hasClass('slick-initialized')) return;

        slider.slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            adaptiveHeight: false,
        });
    }, []);

    return (
        <section className="team-section">
            <div className="team-slider">
                {/* Slide 1 */}
                <div className="team-slide slick-slide">

                    <div className="text-content section">
                        <h2 className="slide-h2">
                            “Empowering businesses with exceptional web development and design
                            solutions to thrive in the digital world.”
                        </h2>
                        <h3 className="slide-h3">Abhi Doshi</h3>
                        <p className="slide-p">Founder</p>
                    </div>
                    <div className="image">
                        <img src={founderImg} alt="Abhi Doshi" />
                    </div>

                </div>

                {/* Slide 2 */}
                <div className="team-slide slick-slide">

                    <div className="text-content section">
                        <h2 className="slide-h2">
                            “Our goal is to empower businesses with websites that not only
                            captivate audiences but also drive results and achieve their
                            objectives.”
                        </h2>
                        <h3 className="slide-h3">Janvi Anadkat</h3>
                        <p className="slide-p">Co-Founder</p>
                    </div>
                    <div className="image">
                        <img src={cofounderImg} alt="Janvi Anadkat" />
                    </div>
                </div>

            </div>
        </section>
    );
};

export default TeamSection;
